
import { Settings2 } from "lucide-react";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { useLanguage } from "@/components/LanguageContext";
import { useLanguagePath } from "@/utils/language";
import { useTranslations } from "@/hooks/useTranslations";

export const ProfileHeader = () => {
  const { t: languageT } = useLanguage();
  const { t } = useTranslations("settings");
  const { getPath } = useLanguagePath();
  
  return (
    <div className="space-y-4 animate-fade-in">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 pb-4 border-b border-slate-100/50">
        <div className="space-y-2">
          <h2 className="text-3xl font-bold tracking-tight gradient-text">{t("title")}</h2>
          <p className="text-muted-foreground">{t("subtitle")}</p>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href={getPath("/student-dashboard")} className="text-flame hover:text-flame/80">
                  {languageT('dashboard.student.settings.dashboard')}
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage className="font-medium">{t("title")}</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        <img src="/lovable-uploads/e79feb48-6e7c-488a-8626-bb79f4bde67a.png" alt="TrainerFOLIO Logo" className="h-12 w-auto" />
      </div>
    </div>
  );
};
